var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 2.72021C8.66602 2.72021 2.66602 8.70688 2.66602 16.0802C2.66602 22.7469 7.54601 28.2802 13.9193 29.2802V19.9469H10.5327V16.0802H13.9193V13.1335C13.9193 9.78688 15.906 7.94688 18.9594 7.94688C20.4127 7.94688 21.9327 8.20022 21.9327 8.20022V11.4935H20.2527C18.5993 11.4935 18.0793 12.5202 18.0793 13.5735V16.0802H21.786L21.186 19.9469H18.0793V29.2802C21.2213 28.784 24.0823 27.1809 26.1459 24.7603C28.2095 22.3397 29.3398 19.2611 29.3327 16.0802C29.3327 8.70688 23.3327 2.72021 15.9993 2.72021Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0d7ad3cef2fd66888ab043c5814cf591.svg";
export { ForwardRef as ReactComponent };